import api from "../../shared/api";
import requestXmlTemplate from "../../models/request/xmlTemplate";
import responseXmlTemplate from "../../models/response/xmlTemplate";

export default {
  namespaced: true,
  state: () => ({
    lang: "tr",
    list: [],
    attributes: {},
  }),
  mutations: {
    updateList(state, payload) {
      state.lang = "tr";
      let items = payload.data ? payload.data.items : payload;
      state.list = items;
    },
    updateLang(state, lang) {
      state.lang = lang;
    },
    clearList(state) {
      state.lang = "tr";
      state.list = [];
    },
  },
  actions: {
    create({ state }, data) {
      if (data.form) {
        api.post(
          `xml-template?lang=${state.lang}`,
          requestXmlTemplate.new(data.form),
          (result) => {
            if (data && data.onSuccess) data.onSuccess(result);
          },
          (error) => {
            if (data && data.onError) data.onError(error);
          },
          () => {
            if (data && data.onFinish) data.onFinish();
          }
        );
      }
    },
    update({ state }, data) {
      api.put(
        `xml-template/${data.id}?lang=${state.lang}`,
        requestXmlTemplate.new(data.form),
        (result) => {
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
    delete({ state }, data) {
      api.delete(
        "xml-template/" + data.id,
        (result) => {
          if (result && result.data && result.data.status !== "error") {
            helper.arrayRemove(state.list, "id", data.id);
          }
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          this.dispatch("xml-template/getList");
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
    restore({}, data) {
      api.restore(
        "xml-template/" + data.id,
        (result) => {
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
    remove({}, data) {
      api.remove(
        "xml-template/" + data.id,
        (result) => {
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
    getList({ commit, state }, data) {
      commit("clearList");
      let route = "all/xml-template";

      if (data && data.deleted) {
        route += "&deleted_at=1";
      }
      api.get(
        route,
        (result) => {
          commit("updateList", result);
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
    getById({ state }, data) {
      api.get(
        `xml-template/${data.id}`,
        (result) => {
          let resultData = responseXmlTemplate.new(result.data.item);
          if (resultData.type) {
            resultData.types = state.types.filter(
              (A) => A.id == resultData.type
            )[0];
          }
          if (data && data.onSuccess) data.onSuccess(resultData);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
    isActive({}, data) {
      const requestData = data ? data.form : null;
      if (requestData) {
        api.post(
          "xml-template/isActive/" + requestData.id,
          {
            is_active: requestData.is_active,
          },
          (result) => {
            if (data && data.onSuccess) data.onSuccess(result);
          },
          (error) => {
            if (data && data.onError) data.onError(error);
          },
          () => {
            if (data && data.onFinish) data.onFinish();
          }
        );
      }
    },
    checkMain({}, data) {
      api.post(
        "xml-template/checkMain",
        {},
        (result) => {
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
    loadXmlAttribute({}, data) {
      api.post(
        "xml-template/loadXmlAttribute",
        { address: data.address },
        (result) => {
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
    getXmlAttribute({state}, data) {
      api.post(
        "xml-template/getTemplateAttribute",
        null,
        (result) => {
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
  },
};
